var collapsable = {
	// breakpoint: bp_cmsMobile+'px',
	breakpoint: bp_tablet_landscape+'px',
	initialized: false,
	collapse: function() {
		var _this = this;
		// show stacker-header
		_this.stackerHeader.addClass('visible');
		// add init class to section
		_this.stackerSection.addClass('collapse-init');
		// collapse sections
		_this.stackerSection.each(function(){
			if ( $(this).data('collapse') == "collapsed") {
				$(this).addClass('collapse');
			} else {
				$(this).addClass('collapse in');
			}
		})
	},

	destroy: function() {
		var _this = this;
		_this.stackerHeader.removeClass('visible');
		_this.stackerSection.css('height','auto');
		_this.stackerSection.removeClass("collapse in");
		_this.stackerSection.removeClass("collapse-init");

		_this.stackerHeader.each(function() {
			if ( $(this).attr('data-collapsed') === 'collapsed') {
				$(this).addClass('collapsed');
			}
		})

		_this.initialized = false;
	},

	init: function() {
		if ( this.initialized ) return;
		
		var _this = this;

		_this.initialized = true;

		_this.stackerSection = $(".stacker-section");
		_this.stackerHeader = $(".stacker-header");

		// on small screen
		//if ( $(window).width() < bootstrap_sm) {
		if ( Modernizr.mq("screen and (max-width:"+_this.breakpoint+")")) {
			_this.collapse();
		}
		// on resize
		$(window).smartresize(function () { 
			// if no initialized, collapse stacker
	    if ( Modernizr.mq("screen and (max-width:"+_this.breakpoint+")") && !_this.stackerSection.hasClass("collapse-init") ) {
				_this.collapse();
			} else if ( !Modernizr.mq("screen and (max-width:"+_this.breakpoint+")") && _this.stackerSection.hasClass("collapse-init")) {
				// if big screen, destroy accordion
				_this.destroy();
			}
	  	})

	}
}